import "react-datepicker/dist/react-datepicker.css";

import ja from "date-fns/locale/ja";
import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";

import { StyledDateInput, StyledDateInputProps } from "./styled";

registerLocale("ja", ja);

type DateInputProps = {
  name?: string;
  date?: Date;
  onChangeHandler: (date: Date) => void;
  onBlurHandler?: React.FocusEventHandler<HTMLInputElement>;
  autoFocus?: boolean;
  readonly?: boolean;
  minDate?: Date;
  maxDate?: Date;
} & StyledDateInputProps;

export const DateInput: React.FC<DateInputProps> = ({
  name,
  date,
  onChangeHandler,
  onBlurHandler,
  autoFocus,
  readonly,
  minDate,
  maxDate,
  ...styles
}) => {
  return (
    <StyledDateInput {...styles}>
      <DatePicker
        name={name}
        selected={date}
        onChange={onChangeHandler}
        onChangeRaw={onBlurHandler}
        readOnly={readonly}
        locale="ja"
        dateFormat="yyyy年MM月dd日"
        className="styled"
        autoFocus={autoFocus}
        minDate={minDate}
        maxDate={maxDate}
      />
    </StyledDateInput>
  );
};
